import React, { useEffect, useState } from "react";
import classes from "./FromToDatePickers.module.scss";
import SingleDatePicker from "./SingleDatePicker";
import { useRecoilState } from "recoil";
import { setUserToLocalStorage } from "../../../../../utils/functions/localStorageManager";
import { format } from "date-fns";

const FromToDatePickers = (props) => {
  const { setFromdate, setTodate, fromDate, toDate, label, disabled } = props;

  const [error, setError] = useState("");

  // useEffect(() => {
  //   //setStartDate(calendar.overtimeFromDate);
  //   setEndDate(calendar.overtimeToDate);
  // }, [calendar]);
  return (
    <div className={classes.mainContainer}>
      <div className={classes.datePickers}>
        <div className={classes.datePicker}>
          <SingleDatePicker
            disabled={disabled}
            // setCurrentDate={setStartDate}
            // currentDate={startDate}
            setCurrentDate={setFromdate}
            currentDate={fromDate}
            order="From"
            setError={setError}
            // compDate={endDate}
            compDate={toDate}
            setCompDate={setTodate}
            label={label}
          />
        </div>
        <div className={classes.datePicker}>
          <SingleDatePicker
            disabled={disabled}
            // setCurrentDate={setEndDate}
            // currentDate={endDate}
            setCurrentDate={setTodate}
            currentDate={toDate}
            order="To"
            setError={setError}
            // compDate={startDate}
            compDate={fromDate}
            setCompDate={setFromdate}
            label={label}
          />
        </div>
      </div>
      {error && <div className={classes.ErrorMessage}>{error}</div>}
    </div>
  );
};

export default FromToDatePickers;
